import React from "react";
import TransactionSummary from "../atom/student/TransactionSummary";

export default function Card({ name, data }) {
  return (
    <div className="w-full mb-5 bg-white rounded-lg border border-gray-200 shadow-md">
      <h5 className="rounded-t-lg p-2 mb-2 text-xl font-bold bg-green-800 text-white">
        {name}
      </h5>
      <p className="font-normal text-gray-700 dark:text-gray-400 p-6">
        <TransactionSummary data={data} />
      </p>
    </div>
  );
}
